import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { useEffect, useState } from "react";
import Errors from "../../models/errors";
import Asset, { newAsset } from "../../models/asset";
import AssetCopyDocumentsForm from "./AssetCopyDocumentsForm";

interface AssetCopyDocumentsModalProps {
  show: boolean;
  asset?: Asset;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const AssetCopyDocumentsModal: React.FC<AssetCopyDocumentsModalProps> = ({
  show,
  asset,
  onCancel,
  onSuccess,
}) => {
  const [initialErrors, setInitialErrors] = useState<Errors>({});
  const [initialAsset, setInitialAsset] = useState<Asset>(
    asset ? asset : newAsset()
  );

  const modalTitle = asset
    ? `Copiar Documentos requeridos por Productor: ${asset.name}`
    : `Copiar Documentos requeridos por Productor`;

  const onClose = () => {
    setInitialErrors({});
    setInitialAsset(newAsset());
    onCancel();
  };
  useEffect(() => {
    setInitialAsset(asset ? asset : newAsset());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [asset]);

  return (
    <CModal show={show} onClose={onClose} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>{modalTitle}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          {show ? (
            <AssetCopyDocumentsForm
              initialAsset={initialAsset}
              initialErrors={initialErrors}
              onCancel={onCancel}
              onSuccess={onSuccess}
            />
          ) : (
            <></>
          )}
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default AssetCopyDocumentsModal;
